import * as React from 'react'

const TimeOption = (props: any) => {
  return (
    <svg
      className={props.className}
      width='25'
      height='25' // Ensure width and height are equal
      viewBox='10 0 30 30' // Adjusted for square view
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M25 0C18.376 0 13.012 5.376 13.012 12C13.012 18.624 18.376 24 25 24C31.624 24 37 18.624 37 12C37 5.376 31.624 0 25 0ZM25 21.6C19.696 21.6 15.4 17.304 15.4 12C15.4 6.696 19.696 2.4 25 2.4C30.304 2.4 34.6 6.696 34.6 12C34.6 17.304 30.304 21.6 25 21.6Z'
        fill='#405264'
      />
      <path
        d='M1.8 0H0V7.2L6.3 10.98L7.2 9.504L1.8 6.3V0Z'
        transform='translate(24 6)' // Adjusted position
        fill='#405264'
      />
    </svg>
  )
}

export default TimeOption



// WEBPACK FOOTER //
// ./src/components/icons/ui/TimeOption.tsx